module.exports = __webpack_public_path__ + "img/4-4.82879837.png";